//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';
export default {
  async asyncData({ $content }) {
    const md = await $content('privacy-policy').fetch();
    return {
      md
    };
  },
  methods: {
    lastUpdated(md) {
      return dayjs(md.updated_at, 'MM-DD-YYYY').format('LL');
    }
  },
  head: {
    title: 'Privacy Policy | BOMIST',
    meta: [{ name: 'robots', content: 'noindex,nofollow,noarchive' }]
  }
};
